/**
 * SplashContainer component.
 */
import Colors from '@shared/assets/style/default/color';
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

/**
 * Styled splash container.
 */
const SplashContainer = styled.div<Props>`
  background: ${Colors.background};
  display: flex;
  height: 100vh;
  justify-content: center;
  position: absolute;
  width: 100vw;
  z-index: 10000000; // Place splash on cmp
`;

export default withOpacity(SplashContainer);
